import React, { useEffect, useState } from 'react';
import { trackButtonClick, trackFormError } from '../../../../services/analytics';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../../services/auth/authService';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Track page view on mount
    // trackCustomPageView('Login Page');

    const checkAuth = async () => {
      try {
        setIsChecking(true);
        console.log('Login page: Checking authentication...');
        // Track login attempt
        trackButtonClick('Login Attempt', 'login-page');

        // Check if user already has valid tokens
        const isAuthenticated = await authService.checkAndRefreshAuth();

        if (isAuthenticated) {
          console.log('User already authenticated - redirecting to dashboard');
          // Track login success
          trackButtonClick('Login Success', 'login-page');
          navigate('/citizenship');
        } else {
          console.log('User not authenticated - initiating login flow');
          setIsChecking(false);
          // Track login flow start
          trackButtonClick('Initiate Login Flow', 'login-page');
          // Initiate OAuth login flow
          authService.initiateLogin();
        }
      } catch (err) {
        console.error('Authentication check failed:', err);
        setError('Authentication failed. Please try again.');
        setIsChecking(false);
        // Track login failure
        trackFormError('citizenship', ['login'], 1);
      }
    };

    checkAuth();
  }, [navigate]);

  if (isChecking) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Checking authentication status...</h2>
        <p>Please wait while we verify your session.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>
        <h2>Error</h2>
        <p>{error}</p>
        <button
          onClick={() => {
            trackButtonClick('Try Again', 'login-page-error');
            window.location.reload();
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>Redirecting to login...</h2>
      <p>Please wait while we redirect you to the authentication page.</p>
    </div>
  );
};

export default Login;